// extracted by mini-css-extract-plugin
module.exports = {"btn-container":"mnr_btn-container__2m9-s","heading":"mnr_heading__U0OqN","refresh-btn":"mnr_refresh-btn__3VVir","upload-history-btn":"mnr_upload-history-btn__3VidT"};